import { combineReducers } from 'redux';
import { atvApi } from 'src/api/atv/atvApi';
import { internalApi } from 'src/api/internal/internalApi';
import transfer from 'src/features/transfer/transferSlice';
import yodleeConfig from 'src/features/transfer/yodleeConfigSlice';
import authSlice from 'src/state/authSlice/authSlice';
import appConfig from './app/appConfigSlice';
import app from './app/appSlice';

const rootReducer = combineReducers({
  app,
  appConfig,
  authSlice,
  transfer,
  yodleeConfig,
  [atvApi?.reducerPath]: atvApi.reducer,
  [internalApi?.reducerPath]: internalApi.reducer,
});

export default rootReducer;
